export default __webpack_public_path__ + "static/media/ic-arrowdown.12a35ff5.svg";